<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="addReport()"
                  particleAnalytics
                  analyticsCategory="data-survey"
                  analyticsAction="Add-Folder">Add Report
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container m-l-10 flex flex-row justify-start items-center">
          <mat-slide-toggle
            [(ngModel)]="showArchived"
            (change)="handleChange($event)">
            Show Archived
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>


  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="dac6-reports" class="content-card mat-white-bg">

        <div class="content pos-relative m-30 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   sortFieldKey="ModifiedDate"
                                   sortDirection="desc"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

